export default function FoPill({ extClassName, intClassName, a, b, children }) {
  return <div className={"flex m-px border-gray-200 border rounded-md "+ (extClassName||"")}>
      <div className="px-2 w-18 bg-gray-100 rounded-l-md">{a}</div>
      <div className={"px-2 " + (intClassName||"")}>{b || ""}{children}</div>
  </div>;
}
